import { useEffect, useState } from 'react';
import { getVendorAccessMe, VendorAccessMe, VendorLevel } from '../../api/client';

/**
 * BUILD-043 - where the signed-in person stands with Vendors (none / view / maintain / administer), as the SERVER answers it for the CURRENT Employee.
 * This only decides what the screens SHOW. It is never the permission: every call is authorized again by the server, which also refuses anything this file lets a
 * button through. One answer is cached per page load and shared (the sidebar and the Vendors page ask the same question once); `refreshVendorAccess` forgets it.
 */
const RANK: Record<VendorLevel, number> = { none: 0, view: 1, maintain: 2, administer: 3 };
export const atLeast = (have: VendorLevel, need: Exclude<VendorLevel, 'none'>) => RANK[have] >= RANK[need];
export const LEVEL_LABEL: Record<VendorLevel, string> = { none: 'No access', view: 'View Vendors', maintain: 'Maintain Vendors', administer: 'Administer Vendors' };

export interface VendorAccessState { me: VendorAccessMe; loading: boolean; unavailable: boolean }
const NONE: VendorAccessMe = { employeeId: null, level: 'none', companyAdmin: false, canGrant: false };
let cached: Promise<{ me: VendorAccessMe; unavailable: boolean }> | null = null;
export function refreshVendorAccess() { cached = null; }
function ask() {
  if (!cached) {
    cached = getVendorAccessMe()
      .then((r) => (r.ok && r.body && typeof (r.body as any).level === 'string' ? { me: r.body as VendorAccessMe, unavailable: false } : { me: NONE, unavailable: r.status >= 500 }))
      .catch(() => ({ me: NONE, unavailable: true }));
  }
  return cached;
}

export function useVendorAccess(): VendorAccessState {
  const [s, setS] = useState<VendorAccessState>({ me: NONE, loading: true, unavailable: false });
  useEffect(() => {
    let live = true;
    ask().then((a) => { if (live) setS({ me: a.me, loading: false, unavailable: a.unavailable }); });
    return () => { live = false; };
  }, []);
  return s;
}
